/** Where an existing account lands after sign-in (web + desktop). */
export const POST_LOGIN_PATH = "/dashboard";

/** Where a brand-new account goes after signup. */
export const POST_SIGNUP_PATH = "/onboarding";

/**
 * Same-origin app paths only. Rejects protocol-relative and absolute URLs.
 */
export function safeAppPath(
  raw: string | undefined | null,
  fallback: string = POST_LOGIN_PATH,
): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//")) {
    return fallback;
  }
  return raw;
}

/** Custom URL scheme registered by the Mac/Windows Prime Assistant app. */
export function desktopAppAuthUrl(token: string, next?: string | null): string {
  const url = new URL("primeassistant://auth/callback");
  url.searchParams.set("token", token);
  url.searchParams.set("next", safeAppPath(next));
  return url.toString();
}
